module.exports = __webpack_public_path__ + "img/help-circle.0fba9c0.svg";